import { create } from "zustand";
import { toast } from "react-toastify";
import { getShopOrders } from "../User/action";

const useShopOrderStore = create((set, get) => ({
    shopOrders: null,
    loadingShopOrders: false,

    getUserShopOrders: async () => {
        set({ loadingShopOrders: true });
        try {
            const response = await getShopOrders();
            if (response) {
                set({ shopOrders: response, loadingShopOrders: false });
            } else {
                set({ loadingShopOrders: false });
            }
            return response;
        } catch (error) {
            set({ loadingShopOrders: false });
        }
    },
}));

export default useShopOrderStore;
